var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background cm px-16" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6" },
        [
          _c(
            "v-col",
            { staticClass: "pl-0", attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backToPrevPage },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v("Back to Contracts"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showApproveContractAlert
        ? _c(
            "v-row",
            { staticClass: "px-16 mb-5 mt-5", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { staticClass: "pl-0 ml-n2", attrs: { cols: "12" } },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "suggestive-class-error",
                      attrs: { color: "#FFDEB8" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "px-2", attrs: { align: "center" } },
                        [
                          _c("v-col", { attrs: { cols: "auto" } }, [
                            _c("img", {
                              staticClass: "mt-2",
                              attrs: { src: _vm.ic_orange_warning },
                            }),
                          ]),
                          _c("v-col", { staticClass: "grow ta-l" }, [
                            _c("label", { staticClass: "error-lbl" }, [
                              _vm._v(
                                " Please inspect information. If this meets criteria please click approve. "
                              ),
                            ]),
                          ]),
                          _vm.lg || _vm.xl
                            ? _c(
                                "v-col",
                                { staticClass: "shrink" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { id: "continue-edit-shipment" },
                                      on: { click: _vm.approveContract },
                                    },
                                    [_vm._v("Approve")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-row",
        { staticClass: "px-16 mb-12 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v("TMS Contract Management"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c("tms-contract-header", {
                attrs: { contract: _vm.contract, carrier: _vm.carrier },
                on: { copyId: _vm.copyId },
              }),
            ],
            1
          ),
          _vm.contract
            ? _c(
                "v-col",
                { staticClass: "mt-6", attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pl-0",
                          class: { "pr-6": _vm.lgAndUp },
                          attrs: { xl: "6", lg: "6", md: "12", height: "100%" },
                        },
                        [
                          _c("tms-contract-basic-info", {
                            on: { updateDates: _vm.showUpdateDatesPopup },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          class: {
                            "pl-6": _vm.lgAndUp,
                            "pl-0 mt-6": _vm.mdAndDown,
                          },
                          attrs: { xl: "6", lg: "6", md: "12", height: "100%" },
                        },
                        [
                          _c("tms-contract-accessorials", {
                            attrs: { accessorials: _vm.contract.accessorials },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.contract
            ? _c(
                "v-col",
                { staticClass: "mt-12", attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "12" } },
                        [_c("contract-rate-info")],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.contract
            ? _c(
                "v-col",
                {
                  staticClass: "mt-12",
                  class: { "pr-6": _vm.mdAndUp, "pl-0": _vm.smAndDown },
                  attrs: { xl: "4", lg: "5", md: "6", sm: "12", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "12" } },
                        [
                          _c("contract-parameters", {
                            attrs: { contract: _vm.contract },
                            on: { updated: _vm.parametersUpdated },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.contract
            ? _c(
                "v-col",
                {
                  staticClass: "mt-12",
                  class: { "pl-6": _vm.mdAndUp, "pl-0": _vm.smAndDown },
                  attrs: { xl: "8", lg: "7", md: "6", sm: "12", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          class: { "pl-0": _vm.smAndDown },
                          attrs: { cols: "12" },
                        },
                        [
                          _c("contract-documents", {
                            attrs: { contract: _vm.contract },
                            on: { updated: _vm.documentsUpdated },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            value: _vm.loading || _vm.approving,
            opacity: "0.9",
            color: "#fff",
          },
        },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.approving
                            ? "Updating the contract"
                            : "Loading Contract Details"
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("contract-dates", {
        attrs: { display: _vm.showUpdateDatesWindow },
        on: {
          close: function ($event) {
            _vm.showUpdateDatesWindow = false
          },
          datesSaved: _vm.datesSaved,
        },
      }),
      _c("smart-toast", {
        attrs: { display: _vm.snackbar, message: _vm.snackbarText },
        on: {
          close: function ($event) {
            _vm.snackbar = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }